import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    bancos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',

    list: [],
    selectList: [],

    bancoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR'(state) {
        state.bancos = [];
        state.totalRegistros = 0;
    },
    'SET_BANCOS'(state, bancos) {
        state.bancos = bancos;
        state.totalRegistros = bancos.length;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, bancos) {
        state.list = bancos;
        state.selectList = bancos.map(banco => banco.nombre.trim());
    },

    'INICIALIZAR_DATOS'(state) {
        state.bancoDatos = [];
    },
    'SET_DATOS'(state, bancoDatos) {
        state.bancoDatos = bancoDatos;
    },
};

const actions = {
    getBancos: ({ commit }) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');

            apiAxios.get('bancos')
                .then(res => {
                    commit('SET_BANCOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
    getList: ({ commit }) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('bancos/list')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
    getDatos ( { commit }, bancoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (bancoId) {
                apiAxios.get('bancos/' + bancoId ) 
                    .then(res => {
                        let bancoDatos = [
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'cuentasVirtuales', 'campo': 'Billetera Electrónica/Plataforma de Pago', 'valor': res.data.cuentasVirtuales? 'Si' : 'No', 'formato': '' },
                        ];

                        commit('SET_DATOS', bancoDatos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
    localidadesProvinciaList (state) {
        return state.localidadesProvinciaList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}